import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AuthService } from '@shared/services/auth.service';
import { NGXLogger } from 'ngx-logger';
import { from, Observable, switchMap } from 'rxjs';

@Injectable()
export class AuthInterceptor implements HttpInterceptor {
  public constructor(private authService: AuthService, private logger: NGXLogger) {}

  public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {

    if(!this.authService.isMsalConfigured){
      return next.handle(req);
    }

    return from(this.authService.getToken()).pipe(
      switchMap(token => {
        if (!token) {
          return next.handle(req);
        }

        const headers = req.headers.set('Authorization', `Bearer ${token}`);

        const requestClone = req.clone({ headers });
        return next.handle(requestClone);
      })
    );
  }


}
